










































import Vue from 'vue';
import _ from 'lodash';

import Requester from '../../requester';

import { Vacinacao } from '../../../../back/src/entity/Vacinacao';

import Confirmar from '../Confirmar.vue';
import IfEmptyTextPrintNA from '../IfEmptyTextPrintNA.vue';
import { VacinacaoSoftDeleteFormData } from '../../../../back/src/types';

export default Vue.extend({
  name: 'VacinacoesRemovidas',
  components: {
    Confirmar,
    IfEmptyTextPrintNA,
  },
  props: {
    vacinacoes: {
      type: Array as () => Vacinacao[],
    },
  },
  data() {
    return {
      loading: {
        submit: false,
      },
      headers: [
        {
          value: 'id',
          text: 'Exame',
          class: 'text-no-wrap',
          sortable: false,
        },
        {
          value: 'data_vacinacao',
          text: 'Data vacina',
          class: 'text-no-wrap',
          sortable: false,
        },
        {
          value: 'usuario_deleted_by.nome',
          text: 'Removido por',
          class: 'text-no-wrap',
          sortable: false,
        },
        {
          value: 'deleted',
          text: 'Removido em',
          class: 'text-no-wrap',
          sortable: false,
        },
        {
          value: 'justificativa',
          text: 'Justificativa',
          class: 'text-no-wrap',
          sortable: false,
        },
        {
          value: 'actions',
          text: 'Ações ',
          class: 'text-no-wrap',
          sortable: false,
          width: '0',
          align: 'center',
        },
      ],
    };
  },
  computed: {
    confirmar(): Vue & { open: (titulo: string, mensagem: string) => boolean } {
      return this.$refs.confirmar as Vue & { open: (titulo: string, mensagem: string) => boolean };
    },
  },
  methods: {
    async restaurarVacinacao(vacinacao: Vacinacao) {
      if (!await this.confirmar.open(
        'Restaurar vacinação',
        'Tem certeza que deseja restaurar este vacinação?',
      )) {
        return;
      }
      const formData: VacinacaoSoftDeleteFormData = {
        id: vacinacao.id as number,
        justificativa: '',
      };
      this.loading.submit = true;
      try {
        const response = await Requester.vacinacao.restauraVacinacao(
          vacinacao.id as number,
          formData,
        );
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
        } else {
          this.$root.$emit('avisoSnackbar', { color: 'success', text: 'Dados salvos com sucesso' });
          this.$emit('restauraVacinacao', response.data);
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading.submit = false;
      }
    },
  },
});
